<template>
  <div class="md:bg-grey-75 md:p-6 rounded-2xl">
    <slot />
  </div>
</template>